export * from './icon';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/icon/index.js
// module id = 444
// module chunks = 8